import React from "react";
import About from "./pages/About"; // Componente About
import Projects from "./components/Projects-comp"; // Componente Projects
import Contact from "./pages/Contact"; // Componente Contact
import Carrossel from "./components/Carrossel"; // Componente Contact
import Card from "./components/Card"; // Componente Contact
import Partners from "./components/Partners";
import Products from "./components/Products"
import Maps from "./components/Maps"
import VideoComponent from "./components/Video";
import { cards } from "./data/cardsData";
import WhatsappButton from "./components/WhatsappButton";
import "./styles/home.css"; // Importando o CSS de Home


const Home = () => {
  return (
    <div>
      {/* Botão do WhatsApp */}
      
        <VideoComponent />
        {/* Carousel */}
        {/* <Carrossel /> */}

        {/* Cards */}
        <div className="container mt-5">
        <div className="row align-items-center justify-content-center">
          {cards.map((card, index) => (
            <Card card={card} key={index} />
          ))}
        </div>
        </div>

        {/* Conteúdo About */}
        <About />

        {/* <Products /> */}

        {/* Conteúdo Projects */}
        {/* <Projects /> */}

        {/* Conteúdo Parceiros */}
        <Partners />
        {/* Conteúdo Contact */}
        <Contact />
        <Maps />

      </div>
  );
};

export default Home;
